import classNames from 'classnames';
import type { CSSProperties } from 'react';
import styles from './LayoutCenter.module.css';
import { LayoutCenterProps } from './types';
function LayoutCenter({
  as: Tag = 'div',
  maxSize = 'fix-content-total',
  gutter = '300',
  className,
  centeredChildren,
  container,
  flex,
  style,
  ...props
}: LayoutCenterProps) {
  return <Tag {...props} className={classNames(styles.center, {
    [styles.centerIntrinsic!]: centeredChildren,
    [styles.container!]: container,
    [styles.flex!]: flex
  }, className)} style={{
    '--container-size': `var(--betterplace-sizing-${maxSize})`,
    '--container-gutters': `var(--betterplace-spacing-${gutter})`,
    ...style
  } as CSSProperties}>
      {props.children}
    </Tag>;
}
export default LayoutCenter;